/**
 * Opciones de entrega para el checkout (CHK-03, ENV-01).
 *
 * Una sola llamada trae las regiones con sus comunas y el costo YA resuelto de
 * cada una. El frontend no combina tarifas ni aplica excepciones: si lo hiciera,
 * el precio que se muestra podria dejar de ser el que se cobra.
 */
import type { OpcionesDespacho } from '@bandu/compartido';

import { pedir } from './cliente-api';

export function obtenerOpcionesDespacho(senal?: AbortSignal): Promise<OpcionesDespacho> {
  return pedir<OpcionesDespacho>('/despacho/opciones', { ...(senal ? { senal } : {}) });
}
